import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6717092b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.addaddress'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
    }, null, 8 /* PROPS */, ["title"]),
    _createVNode(_component_van_field, {
      modelValue: $setup.name,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => (($setup.name) = $event)),
        $setup.checkText
      ],
      placeholder: $setup.t('me.srname')
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
    _createVNode(_component_van_field, {
      modelValue: $setup.phone,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => (($setup.phone) = $event)),
        $setup.checkText
      ],
      placeholder: $setup.t('me.srndsjh')
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
    _createVNode(_component_van_field, {
      modelValue: $setup.address,
      "onUpdate:modelValue": [
        _cache[3] || (_cache[3] = ($event: any) => (($setup.address) = $event)),
        $setup.checkText
      ],
      type: "textarea",
      placeholder: $setup.t('me.addressdetail')
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
    _createVNode(_component_van_field, {
      modelValue: $setup.code,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => (($setup.code) = $event)),
        $setup.checkText
      ],
      placeholder: $setup.t('me.inputcode')
    }, null, 8 /* PROPS */, ["modelValue", "placeholder"]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.submit()))
    }, _toDisplayString(_ctx.$t('me.submit')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, _toDisplayString($setup.t('me.inputdetail')), 1 /* TEXT */)
  ]))
}